import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Link from '@mui/material/Link';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import { StoreState } from '../../../store';
import { useNextQuoteEdition } from '../../../hooks';

const getCurrentQuoteUUID = (state: StoreState) =>
  state.quoteWizard.currentQuoteUUID;

export function QuoteWizardQuoteHasNextEditionWarning() {
  const currentQuoteUUID = useSelector(getCurrentQuoteUUID);
  const relationship = useNextQuoteEdition(currentQuoteUUID);
  const [isRenewal, setIsRenewal] = useState<boolean>(false);
  const [nextEditionUUID, setNextEditionUUID] = useState<string | null>(null);

  useEffect(() => {
    if (relationship) {
      setIsRenewal(relationship.reason === 'RENEWAL');
      setNextEditionUUID(relationship.nextEdition?.uniqueID || null);
    } else {
      setIsRenewal(false);
      setNextEditionUUID(null);
    }
  }, [relationship]);

  return (
    <Collapse in={!!relationship && !!nextEditionUUID}>
      <Alert severity='error'>
        {isRenewal
          ? 'This quote has been renewed. View the '
          : 'This quote has a next edition. View the '}
        <Link href={`/insurtech/manager/quotes/details/${nextEditionUUID}`}>
          {isRenewal ? 'renewed edition' : 'next edition'}
        </Link>
        .
      </Alert>
    </Collapse>
  );
}
